<script>
export default {
  props: {
    active: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      activeItem: this.active
    }
  },
  watch: {
    active: {
      handler(val) {
        if (this) {
          this.activeItem = val
        }
      }
    }
  },
  methods: {
    activate(item) {
      if (item < 0) {
        item = 0
      } 
      return this.activeItem = item
    }
  },
  render() {
    return this.$scopedSlots.default({
      activeItem: this.activeItem,
      activate: this.activate
      
    })
  },
}
</script>
